var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"energielabel",class:_vm.labelClass,attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.resolvedLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }